import { render, staticRenderFns } from "./WokIconWarningC64.vue?vue&type=template&id=111a85f4&functional=true&"
import script from "./WokIconWarningC64.vue?vue&type=script&lang=ts&"
export * from "./WokIconWarningC64.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports